module.exports = __webpack_public_path__ + "img/fi-rr-headphones.398ba3dd.svg";